/**
 * @module
 *
 * This file is slimmed down copy of the MenuButton implementation in nova-commons.
 * The important difference is that this menu button has some bold text (the value after the field text).
 * If that was supported in nova-commons, then this wouldn't be needed.
 */
import { __rest } from "tslib";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React from 'react';
import { ButtonVariant } from '@sas/nova-commons/components/Button';
/* eslint-disable no-restricted-imports */
import { BaseButton } from '@sas/nova-commons/components/Button/__internal__/BaseButton';
import { BaseMenuButton, getMenuButtonTokens, } from '@sas/nova-commons/components/MenuButton/__internal__';
/* eslint-enable no-restricted-imports */
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { Icon } from '@sas/nova-commons/components/Icon';
import { ArrowSmallDownBtn } from '@sas/react-svg';
import { InfoBarState } from '../../store/infoBar/InfoBarState';
import { createUseHtmlId } from '@sas/nova-commons/hooks/useHtmlId';
import { selectInfoBarState, selectStyleState } from '../../store/selectors';
import cx from 'classnames';
import cn from './InfoBar.css.json';
import './InfoBar.css';
const useLabelId = createUseHtmlId('InfoBarMenuButtonLabel');
const InfoBarMenuButtonBase = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const dt = useDesignTokens();
    const labelId = useLabelId();
    const fontSize = (_c = (_b = (_a = props.style) === null || _a === void 0 ? void 0 : _a.font) === null || _b === void 0 ? void 0 : _b.fontSize) !== null && _c !== void 0 ? _c : dt.reportTokens.font.size.m;
    const fg = (_f = (_e = (_d = props.style) === null || _d === void 0 ? void 0 : _d.normal) === null || _e === void 0 ? void 0 : _e.fg) !== null && _f !== void 0 ? _f : dt.reportTokens.text.basic.fg;
    const inlineVars = renderInlineCssVars({ fg: fg, 'font-size': fontSize, 'font-family': (_h = (_g = props.style) === null || _g === void 0 ? void 0 : _g.font) === null || _h === void 0 ? void 0 : _h.fontFamily }, 'info');
    if (props.state === undefined) {
        return null;
    }
    else if (props.state.sections === undefined) {
        return (React.createElement("div", { className: cn.readOnlyContainer, style: inlineVars },
            !!props.state.field && (React.createElement("span", { className: cx(cn.menuButtonLabel, props.state.italicizeField && cn.italic) }, props.state.field)),
            !!props.state.value && (React.createElement("span", { className: cn.menuButtonValue, title: (_j = props.state) === null || _j === void 0 ? void 0 : _j.tooltip }, props.state.value))));
    }
    else {
        return (React.createElement(BaseMenuButton, { sections: props.state.sections, onItemSelected: (location) => {
                if (props.state) {
                    const notify = props.actions.notifyMenuButtonSelection;
                    notify(props.id, {
                        menuButtonIndex: props.index,
                        location,
                        menu: props.state,
                    });
                }
            }, text: props.state.value, renderButton: (_a) => {
                var _b, _c, _d;
                var { setButtonRef, menuIsOpen, text } = _a, buttonProps = __rest(_a, ["setButtonRef", "menuIsOpen", "text"]);
                return (React.createElement(BaseButton, Object.assign({ tokens: () => getMenuButtonTokens(!!menuIsOpen, buttonProps.variant, text, dt) }, buttonProps, { className: cx(cn.menuButton, buttonProps.className), ref: setButtonRef, variant: ButtonVariant.Light, "aria-haspopup": true, ariaLabelledBy: labelId }),
                    React.createElement("span", { id: labelId, className: cx(cn.menuButtonLabel, ((_b = props.state) === null || _b === void 0 ? void 0 : _b.italicizeField) && cn.italic), style: inlineVars }, (_c = props.state) === null || _c === void 0 ? void 0 : _c.field),
                    React.createElement("span", { style: inlineVars, className: cn.menuButtonValue, title: (_d = props.state) === null || _d === void 0 ? void 0 : _d.tooltip }, text),
                    React.createElement(Icon, { tokens: () => ({ fg }), className: cn.menuButtonArrow, icon: ArrowSmallDownBtn, tooltip: "", ariaHidden: true })));
            } }));
    }
};
export const InfoBarMenuButton = connect((state, props) => {
    var _a;
    const menuButtonData = (_a = selectInfoBarState(state, props.id).menuButtons) === null || _a === void 0 ? void 0 : _a[props.index];
    return { state: menuButtonData, style: selectStyleState(state, props.id) };
}, (dispatch) => ({
    actions: bindActionCreators(InfoBarState.actions, dispatch),
}))(InfoBarMenuButtonBase);
